exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr td {\r\n    height: 10px;\r\n    padding: 0.2rem;\r\n}\r\n\r\n.row {\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n}\r\n\r\n.ng-option {\r\n    height: auto !important;\r\n}\r\n\r\n.ng-select.custom ::ng-deep .ng-value  {\r\n   color:#2D5586;\r\n   font-weight:bold;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/average-traffic/average-traffic.component.css
// module id = ../../../../../src/app/average-traffic/average-traffic.component.css
// module chunks = main